var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "qrcode-content",
      style: { width: _vm.size * _vm.scale + "px" }
    },
    [
      _c("vue-qr", {
        attrs: {
          text: _vm.text,
          margin: _vm.margin,
          colorDark: _vm.color,
          colorLight: "#fff",
          logoSrc: _vm.logoSrc,
          logoCornerRadius: 4,
          logoScale: _vm.logoScale,
          size: _vm.size
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1fd5244", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1fd5244","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QrCode.vue
// module id = 505
// module chunks = 4